// This controller can be used to quickly and easily reset any HTML element
// to an initial state, while preserving Stimulus event handlers
// Said initial state can be stored on connect or manually saved anytime

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['element']

  static values = {
    saveOnConnect: Boolean
  }

  connect() {
    if (this.hasSaveOnConnectValue && this.saveOnConnectValue) this.saveState()
  }

  saveState() {
    this.elementInitialState = this.elementTarget.cloneNode(true)
  }

  reset() {
    this.elementTarget.innerHTML = this.elementInitialState.innerHTML
  }
}
